export default function PrevDateIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.62672 6.02622C9.93461 5.74913 9.95957 5.27491 9.68247 4.96703C9.40538 4.65914 8.93116 4.63419 8.62328 4.91128L9.62672 6.02622ZM6.3125 8L5.81078 7.44253C5.65274 7.58476 5.5625 7.78738 5.5625 8C5.5625 8.21262 5.65274 8.41524 5.81078 8.55747L6.3125 8ZM8.62328 11.0887C8.93116 11.3658 9.40538 11.3409 9.68247 11.033C9.95957 10.7251 9.93461 10.2509 9.62672 9.97378L8.62328 11.0887ZM14 8C14 11.3137 11.3137 14 8 14V15.5C12.1421 15.5 15.5 12.1421 15.5 8H14ZM8 14C4.68629 14 2 11.3137 2 8H0.5C0.5 12.1421 3.85786 15.5 8 15.5V14ZM2 8C2 4.68629 4.68629 2 8 2V0.5C3.85786 0.5 0.5 3.85786 0.5 8H2ZM8 2C11.3137 2 14 4.68629 14 8H15.5C15.5 3.85786 12.1421 0.5 8 0.5V2ZM8.62328 4.91128L5.81078 7.44253L6.81422 8.55747L9.62672 6.02622L8.62328 4.91128ZM5.81078 8.55747L8.62328 11.0887L9.62672 9.97378L6.81422 7.44253L5.81078 8.55747Z"
        fill="currentColor"
      />
    </svg>
  );
}
